import React from 'react';
import ReactDOM from 'react-dom';
// eslint-disable-next-line
import Login from './Component/Authentication/Login';
import './index.css';

ReactDOM.render(<Login/>, document.getElementById('root'));